export default __webpack_public_path__ + "static/media/logo-small.88a5b62e.jpg";